// version.ts
export const getCurrentVersion = async () => {
  const versionFileUrl = `/meta.json?timeStamp=${Date.now()}`;
  try {
    const response = await fetch(versionFileUrl, { cache: "no-cache" });
    const data = await response.json();
    return data.version;
  } catch (error) {
    console.error("Failed to fetch version:", error);
    return null;
  }
};
